"use client";
import Form from "antd/es/form";
import Spin from "antd/es/spin";
import { useEffect, useState } from "react";
import FormTextArea from "../form-items/FormTextArea";
import { PlayCircle } from "lucide-react";
import { toast } from "sonner";

export default function FbExtractor() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [data, setData] = useState({
    input: ``,
  });
  const [sources, setSources] = useState([] as any);

  useEffect(() => {
    form.setFieldsValue(data);
  }, []);

  async function onFormChange() {
    const val = form.getFieldsValue();
    setData(val);
  }

  const onSubmit = async () => {
    setIsLoading(true);
    const arr = [] as any;
    const input = form.getFieldValue("input");
    const findBrowserNative = (inputString: string, key: string) => {
      // const regex = new RegExp(`\"${key}\":\"https.*?\"`, "gm");
      const regex = new RegExp(/"[^"]*video[^"]*fbcdn\.net[^"]*"/, "gm");

      const matches = inputString.match(regex);

      for (const match of matches || []) {
        const jsonObject = JSON.parse("{" + match + "}");
        arr.push({
          quality: key == "browser_native_hd_url" ? "HD" : "SD",
          url: jsonObject[key],
        });
      }
    };

    const findVideo = (inputString: string) => {
      const regex = new RegExp(/"base_url":\s*"[^"]*"/, "gm");
      const matches = inputString.match(regex);
      for (const match of matches || []) {
        const jsonObject = JSON.parse("{" + match + "}");
        console.log(jsonObject["base_url"]);
        arr.push({
          quality: "SD",
          url: jsonObject["base_url"],
        });
      }
    };

    var parser = new DOMParser();
    var doc = parser.parseFromString(input, "text/html");
    var jsonScript = doc.querySelectorAll('script[type="application/json"]');
    jsonScript.forEach((script) => {
      findBrowserNative(script.innerHTML, "browser_native_hd_url");
      findBrowserNative(script.innerHTML, "browser_native_sd_url");
    });

    findVideo(input);

    if (!arr.length) {
      toast.error("No video found");
    }
    if (arr.length) setSources(arr);
    setIsLoading(false);
  };

  const onDownload = async (source: string) => {
    window.open(`${source}&dl=1`, "_blank");
  };

  return (
    <Spin spinning={isLoading} tip="Loading...">
      <div className="mt-16 text-center">
        <h1 className="text-2xl">
          Facebook <span className="text-blue-600">Private Video</span>{" "}
          Downloader
        </h1>
        <h2 className="text-lg text-on-surface ">
          Video Private 1080p - 2K - 4K. Free. All devices
        </h2>
      </div>
      <div className="mt-5 flex h-full gap-10 pt-4 md:flex-row md:gap-10 md:pt-0">
        <div
          className={
            "flex-none rounded-xl border border-outline-variant bg-surface-variant duration-300 md:h-[500px] " +
            (sources.length ? "w-[340px]" : "w-full")
          }
        >
          <div className="flex flex-col space-y-1.5 p-6">
            <h3 className="text-xl font-semibold leading-none">
              Facebook extractor
            </h3>
            <p className="text-sm text-on-surface">Extract video</p>
          </div>
          <div className="p-6 pt-0">
            <Form
              form={form}
              onChange={onFormChange}
              layout="vertical"
              initialValues={data}
            >
              <div className="grid w-full items-center">
                <div className="flex flex-col">
                  <FormTextArea
                    name="input"
                    label="Source code"
                    rows={12}
                  ></FormTextArea>
                </div>
              </div>
            </Form>
          </div>
          <div className="flex items-center p-6 pt-0">
            <button
              className="focus-visible:ring-ring inline-flex h-9 w-full items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow transition-colors hover:bg-blue-600/90 focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50"
              onClick={onSubmit}
            >
              Extract
            </button>
          </div>
        </div>
        <div
          className={
            "h-[500px] flex-col overflow-y-auto rounded-lg border border-outline-variant bg-surface-variant p-4   " +
            (sources.length ? "flex-1" : "w-0 flex-none")
          }
        >
          {sources.map((source: any, i: number) => (
            <div
              key={i}
              className="flex items-center justify-between gap-4 border-b border-b-gray-100 py-4 text-sm"
            >
              <div className="flex-none break-all font-semibold">
                <div className="relative h-[80px] w-[120px]">
                  <a href={source.url} target="_blank">
                    <video
                      src={source.url}
                      className="h-full w-full object-cover"
                    ></video>
                    <PlayCircle className="absolute left-1/2 top-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 transform cursor-pointer text-white" />
                  </a>
                </div>
              </div>
              <div className="w-[500px] font-semibold">
                <div className="... truncate">{source.quality}</div>
              </div>
              <div className="flex-none font-semibold">
                <button
                  onClick={() => onDownload(source.url)}
                  className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10"
                >
                  Download
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Spin>
  );
}
